import * as tslib_1 from "tslib";
import { UserService } from './user.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { take } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/fire/firestore";
import * as i2 from "./user.service";
var ModuleService = /** @class */ (function () {
    function ModuleService(firestore, userService) {
        this.firestore = firestore;
        this.userService = userService;
    }
    ModuleService.prototype.getModuleToken = function (username, module) {
        return this.firestore
            .collection("module_token", function (ref) { return ref.where('username', '==', username).where('module', '==', module); })
            .snapshotChanges();
    };
    /**
     * Cek sekali (take(1)) apakah permission module di Firestore `module_token` berubah dibanding
     * token di localStorage; reload hanya kalau ISI permission-nya beda.
     *
     * Sejak token module v2 (`{permissions, userid, exp}`, 2026-09-03) tiap panggilan
     * get-permissions menerbitkan string token baru (exp berbeda) walau permission-nya sama.
     * Membandingkan string token + listener permanen dulu bikin reload terus-menerus (IF-84):
     * tiap load me-mint token baru -> Firestore berubah -> tab/app lain (ptnw-3.0) reload -> dst.
     */
    ModuleService.prototype.syncModuleToken = function (moduleName) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var username;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (location.hostname != "localhost" && location.hostname != "127.0.0.1") {
                    username = this.userService.getUsername();
                    this.getModuleToken(username, moduleName).pipe(take(1)).subscribe(function (res) {
                        var data = res.map(function (e) {
                            return tslib_1.__assign({ documentId: e.payload.doc.id }, e.payload.doc.data());
                        }).shift();
                        // doc module_token untuk user+module ini belum ada / tanpa token
                        if (!data || data.token == null) {
                            return;
                        }
                        var current = localStorage.getItem(moduleName);
                        if (current === data.token) {
                            return;
                        }
                        var currentPayload = _this.decodeToken(current);
                        var remotePayload = _this.decodeToken(data.token);
                        var remotePermissions = _this.getPermissions(remotePayload);
                        if (currentPayload && remotePermissions && _this.samePermissions(_this.getPermissions(currentPayload), remotePermissions)) {
                            // permission sama, hanya beda terbitan -- pakai yg exp-nya paling lama, tanpa reload
                            if ((remotePayload.exp || 0) > (currentPayload.exp || 0)) {
                                localStorage.setItem(moduleName, data.token);
                            }
                            return;
                        }
                        // permission benar2 berubah (mis. diubah admin) -> reload sekali supaya menu/guard ikut
                        localStorage.setItem(moduleName, data.token);
                        document.location.reload();
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    ModuleService.prototype.decodeToken = function (token) {
        if (!token) {
            return null;
        }
        try {
            var payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
            return JSON.parse(atob(payload));
        }
        catch (ex) {
            return null;
        }
    };
    /** format lama = array datar route, format v2 = {permissions, userid, exp} */
    ModuleService.prototype.getPermissions = function (payload) {
        if (!payload) {
            return null;
        }
        if (Array.isArray(payload)) {
            return payload;
        }
        return Array.isArray(payload.permissions) ? payload.permissions : null;
    };
    ModuleService.prototype.samePermissions = function (a, b) {
        if (!a || !b || a.length !== b.length) {
            return false;
        }
        var sortedB = b.slice().sort();
        return a.slice().sort().every(function (value, i) { return value === sortedB[i]; });
    };
    ModuleService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ModuleService_Factory() { return new ModuleService(i0.ɵɵinject(i1.AngularFirestore), i0.ɵɵinject(i2.UserService)); }, token: ModuleService, providedIn: "root" });
    return ModuleService;
}());
export { ModuleService };
